import theme from '../../muiTheme';

const styles = {

    container: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '95vw',
      borderRadius: 0,
    },
    media: {
        borderRadius: '0px',
        objectFit: 'contain',
        //minWidth: '40vw',
        maxWidth: '50vw',
        maxHeight: '90vh',
    
        [theme.breakpoints.down('sm')]: {
          maxHeight: '100vh',
          minWidth: '100vw'
        },
      },
      card: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '0px',
        boxSizing: 'border-box',
        borderRadius: '10px',
        // width: '80vw',
        [theme.breakpoints.down('sm')]: {
          flexWrap: 'wrap',
          flexDirection: 'column',
        },
      },
      section: {
        borderRadius: '0px',
        padding: '0px',
        maxWidth: '500px',
        minWidth: '450px',
        maxHeight: '75vh',
        overflowY: 'scroll'
      },
      descriptionSection: {
        position: 'sticky',
        top: '100px',
        padding: '20px',

      },
      actionsSection: {
        backgroundColor: 'white',
        position: 'relative',
        zIndex: '2',
        //boxShadow: '0 0 15px rgb(0 0 0 / 12%)'
      },
      imageSection: {
        minHeight: '80vh',
        display: 'flex',
        transition: '0.5s',
        backgroundColor: 'black',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: '0px',
        [theme.breakpoints.down('sm')]: {
          marginLeft: 0,
        },
      },
      blurredBackground: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%'
      },
      loadingPaper: {
        display: 'flex',
        justifyContent: 'center', 
        alignItems: 'center', 
        padding: '20px', 
        borderRadius: '15px', 
        height: '39vh',
      },
      tagContainer: {
        display: 'inline-flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        margin: '15px 0px'
      },
      postTag: {
        padding: '5px 12px',
        margin: '5px 4px',
        borderRadius: '20px',
        transition: '0.3s',
        cursor: 'pointer',
        backgroundColor: theme.palette.faint,
        '&:hover, &:active, &:focus': {
          backgroundColor: theme.palette.primary.main,
          color: 'white'
        }
      },
      userAvatar: {
        borderRadius: '60px',
        width: '60px',
        height: '60px',
        backgroundColor: 'black',
        border: '1px solid white',
        boxSizing: 'content-box',
        cursor: 'pointer',
      },
      userInfo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: '10px',
        cursor: 'pointer',
      },
      userName: {
        
        fontWeight: 'normal'
      },
      createdAt: {
        color: theme.palette.gray,
        fontStyle: 'italic'
      },
      avatarContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start'
      },
}

export default styles; 